import { FC } from 'react'
import { IconProps } from '../../../__legacy__/components/core/icons'

export const EmptyStateIcon: FC<IconProps> = (props) => (
  <svg
    width="123"
    height="114"
    viewBox="0 0 123 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.0476 85.8828V31.8585C13.0476 31.09 13.8784 30.6087 14.5451 30.991L60.7826 57.5048C61.0934 57.6831 61.2851 58.014 61.2851 58.3723V112.073C61.2851 112.839 60.4589 113.321 59.7923 112.943L13.5547 86.7529C13.2413 86.5754 13.0476 86.243 13.0476 85.8828Z"
      fill="url(#paint0_linear_1627_10164)"
      stroke="white"
      strokeLinejoin="round"
    />
    <path
      d="M110.197 85.5449V32.3371C110.197 31.5748 109.378 31.0928 108.712 31.4628L61.7997 57.5072C61.4821 57.6835 61.2851 58.0182 61.2851 58.3815V112.074C61.2851 112.84 62.1107 113.322 62.7774 112.945L109.69 86.4153C110.003 86.2379 110.197 85.9053 110.197 85.5449Z"
      fill="url(#paint1_linear_1627_10164)"
      stroke="white"
      strokeLinejoin="round"
    />
    <path
      d="M60.6614 2.92547L13.562 29.9094C13.177 30.13 13.2651 30.5206 13.7642 30.8047L60.4323 57.3796C60.9846 57.6941 61.8179 57.7549 62.2463 57.5118L109.51 30.6911C109.897 30.4711 109.811 30.08 109.312 29.795L62.4797 3.057C61.9261 2.74094 61.0891 2.68039 60.6614 2.92547Z"
      fill="url(#paint2_linear_1627_10164)"
      stroke="white"
      strokeLinejoin="round"
    />
    <path
      d="M46.5009 80.5734L42.2364 78.0177C41.6335 77.6564 41.2645 77.0051 41.2645 76.3022V64.2604V50.4709C41.2645 48.949 42.8967 47.9847 44.2297 48.7191L48.4941 51.0687C49.1325 51.4205 49.529 52.0916 49.529 52.8204V78.8579C49.529 80.412 47.834 81.3723 46.5009 80.5734Z"
      fill="#BEBEBE"
    />
    <path
      d="M30.2364 71.4885L25.9719 68.9328C25.369 68.5714 25 67.9202 25 67.2173V55.1754V41.3859C25 39.864 26.6322 38.8998 27.9651 39.6342L32.2296 41.9838C32.868 42.3355 33.2645 43.0066 33.2645 43.7355V69.7729C33.2645 71.3271 31.5694 72.2874 30.2364 71.4885Z"
      fill="#BEBEBE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 93.7778V70.1001L28.5843 70.4374V94.1151L28 93.7778Z"
      fill="#BEBEBE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44 103.308V79.1226L44.5843 79.4599V103.645L44 103.308Z"
      fill="#BEBEBE"
    />
    <rect x="61" y="3.00049" width="1" height="54" rx="0.5" fill="white" />
    <rect
      x="61"
      y="3.00049"
      width="1"
      height="54"
      rx="0.5"
      fill="url(#paint3_linear_1627_10164)"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.6488 69.0059C94.6922 69.5582 93.9217 70.9082 93.6542 72.1196C92.9521 75.2997 90.8894 78.3632 88.6779 79.64C86.4663 80.9168 84.453 80.2066 83.8241 77.795C83.5845 76.8764 82.8379 76.4023 81.8813 76.9546C80.9247 77.5069 80.1123 78.8717 80.2652 79.8627C80.9456 84.2738 84.3009 86.1581 88.6252 83.6615C92.9495 81.1649 96.4056 75.348 97.2128 70.078C97.3941 68.894 96.6053 68.4537 95.6488 69.0059Z"
      fill="#BEBEBE"
    />
    <path
      d="M78.1051 75.1575C79.8199 74.1373 81.2101 71.6926 81.2101 69.6972C81.2101 67.7018 79.8199 66.9113 78.1051 67.9315C76.3902 68.9517 75 71.3964 75 73.3918C75 75.3872 76.3902 76.1778 78.1051 75.1575Z"
      fill="#BEBEBE"
    />
    <path
      d="M96.7353 64.0745C98.4502 63.0543 99.8404 60.6096 99.8404 58.6142C99.8404 56.6188 98.4502 55.8282 96.7353 56.8485C95.0204 57.8687 93.6302 60.3134 93.6302 62.3088C93.6302 64.3042 95.0204 65.0948 96.7353 64.0745Z"
      fill="#BEBEBE"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1627_10164"
        x1="37.1664"
        y1="30.1323"
        x2="37.1664"
        y2="113.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAFAFA" />
        <stop offset="1" stopColor="#E9E9E9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1627_10164"
        x1="85.7412"
        y1="30.6382"
        x2="85.7412"
        y2="113.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAFAFA" />
        <stop offset="1" stopColor="#E9E9E9" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1627_10164"
        x1="61"
        y1="-3.06493e-06"
        x2="61"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAFAFA" />
        <stop offset="1" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1627_10164"
        x1="61.5"
        y1="3.00049"
        x2="61.5"
        y2="57.0005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#B0B0B0" />
      </linearGradient>
    </defs>
  </svg>
)
